import { collection, doc, type FirestoreDataConverter, getFirestore } from 'firebase/firestore'
import { type z } from 'zod'

import { TeamZod } from '@/model/firestore/schema/TeamZod.ts'
import { ErrorWithSentryCaptureContext } from '@/sentry/ErrorWithSentryCaptureContext.ts'

export type TeamSnapshotData = z.infer<typeof TeamZod> & { _id: string }

const TeamConverter: FirestoreDataConverter<TeamSnapshotData> = {
  toFirestore: (data) => data,
  fromFirestore: (snapshot, options) => {
    const result = TeamZod.safeParse(snapshot.data(options))
    if (!result.success) {
      throw new ErrorWithSentryCaptureContext(
        `Invalid team ${snapshot.id}`,
        {
          tags: { 'firestore.zod': 'teams' },
          fingerprint: ['firestore', 'zod', 'teams'],
          extra: { data: snapshot.data(options), document: { path: snapshot.ref.path } },
        },
        { cause: result.error }
      )
    }
    return { _id: snapshot.id, ...result.data }
  },
}

export const teamCollection = () => collection(getFirestore(), 'teams').withConverter(TeamConverter)

export const teamDocument = (id: string) => doc(getFirestore(), 'teams', id).withConverter(TeamConverter)
